import { Voucher } from '@/scopes/common/components/Voucher/Voucher'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { getVoucherUrl } from '../../domain/policies/voucherUrl'

interface VoucherCardProps {
  value: number
  expirationDate: string
  link: string
}

export function VoucherCard({
  value,
  expirationDate,
  link,
}: VoucherCardProps) {
  const siteName = useConfiguration('siteName')
  const urlFormatted = getVoucherUrl(siteName, link)

  if (urlFormatted) {
    return <Voucher mode="link" amount={value} expirationDate={expirationDate} href={urlFormatted} />
  }

  return <Voucher amount={value} expirationDate={expirationDate} />
}
